import React, { useEffect } from 'react';
import { HashRouter } from 'react-router-dom';
import { AppProvider, useAppContext } from './context/AppContext';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Canvas from './components/Canvas';
import FooterLinks from './components/FooterLinks';
import PurchaseModal from './components/PurchaseModal';
import SuccessModal from './components/SuccessModal';
import WelcomeModal from './components/WelcomeModal';
import AuthModal from './components/AuthModal';
import SocialProofTicker from './components/SocialProofTicker';
import UrgencyBanner from './components/UrgencyBanner';
import PixelCounter from './components/PixelCounter';
import MobileBar from './components/MobileBar';
import AffiliateBanner from './components/AffiliateBanner';
import RankingsPage from './pages/RankingsPage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AdminPage from './pages/AdminPage';
import MyBlocksPage from './pages/MyBlocksPage';
import AffiliatePage from './pages/AffiliatePage';
import { useStripeReturn } from './hooks/useStripeReturn';

function AppInner() {
  const { currentPage } = useAppContext();
  useStripeReturn();

  useEffect(() => {
    document.body.style.overflow = currentPage === 'home' ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; };
  }, [currentPage]);

  if (currentPage === 'rankings') return <RankingsPage />;
  if (currentPage === 'about') return <AboutPage />;
  if (currentPage === 'privacy') return <PrivacyPage />;
  if (currentPage === 'terms') return <TermsPage />;
  if (currentPage === 'admin') return <AdminPage />;
  if (currentPage === 'myblocks') return <MyBlocksPage />;
  if (currentPage === 'affiliate') return <AffiliatePage />;

  return (
    <div className="relative w-screen h-screen overflow-hidden select-none" style={{ background: '#050010' }}>
      <Header />
      <div className="hidden md:block">
        <Sidebar />
      </div>
      <Canvas />
      <SocialProofTicker />
      <div className="hidden md:block">
        <UrgencyBanner />
        <PixelCounter />
        <AffiliateBanner />
      </div>
      <FooterLinks />
      <div className="block md:hidden">
        <MobileBar />
      </div>
      <PurchaseModal />
      <SuccessModal />
      <WelcomeModal />
      <AuthModal />
    </div>
  );
}

export default function App() {
  return (
    <HashRouter>
      <AppProvider>
        <AppInner />
      </AppProvider>
    </HashRouter>
  );
}